<template>
  <div class="after-menu-bar-padding">
    <b-container fluid class="md-content" >
        <div class="md-header">Store Einstellungen</div>
        <b-card>
            <b-row>
                
                <b-col>
                    <b-button variant="primary" @click="refresh()">Aktualisieren</b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-if="settings != undefined">
                <b-col>
                    <b-table striped hover :borderless="true" :outlined="false" :items="settings" :fields="fields">
                        <template slot="contractRequired" slot-scope="row">
                                    <i v-bind:class="{'fas fa-check': row.item.contractRequired, 'fas fa-times': !row.item.contractRequired}"></i>
                        </template>
                        <template slot="actions" slot-scope="row">
                            <b-button class="mx-1" size="sm" v-on:click="openViewModal(row)"><i class="fas fa-eye"></i></b-button>
                            <b-button class="mx-1" size="sm" v-on:click="openEditModal(row)"><i class="fas fa-pencil-alt"></i></b-button>
                            
                        </template>
                        
                    </b-table>
                </b-col>
            </b-row>
        </b-card>
    </b-container>

    

    <b-modal ref="modal-editsetting"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Store Einstellungen bearbeiten" @cancel="hideModal('modal-editsetting')" @ok="editStoreSetting" cancel-title="Abbrechen">
        <b-container fluid>
            <div>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="UTC Abweichung" label-for="cer2" >
                    <b-form-input min="-1440" max="1440" id="cer2" v-model.number="storeSetting.utcOffset" step="1"  type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Pausenzeit" label-for="cer2" >
                    <b-form-input min="0" max="1440" id="cer2" v-model.number="storeSetting.defaultBreakTime" step="1"  type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Latitude" label-for="cer2" >
                    <b-form-input min="0" id="cer2" v-model.number="storeSetting.latitude" step="0.00001" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Longitude" label-for="cer3">
                    <b-form-input min="0" id="cer3" v-model.number="storeSetting.longitude" step="0.00001" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Geöffnet Von" label-for="cer4">
                    <b-form-input id="cer4" v-model="storeSetting.openFrom" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Geöffnet Bis" label-for="cer5">
                    <b-form-input id="cer5" v-model="storeSetting.openTo" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Vertrag notwendig" label-for="cer6">
                     <b-form-checkbox id="cer6" v-model="storeSetting.contractRequired">
                    </b-form-checkbox>
                </b-form-group>


            </div>
           
            <b-row v-if="settingerror">
                Fehler beim Bearbeiten der Settings.
            </b-row>
        </b-container>
    </b-modal>


   <b-modal ref="modal-viewsetting"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Store Einstellungen Detail" @cancel="hideModal('modal-viewsetting')" @ok="hideModal('modal-viewsetting')" cancel-title="Abbrechen">
        <b-container fluid>
         <b-card no-body>
            <b-tabs card>   
                <b-tab title="Settings & Infos">
                    <div v-if="settingId != undefined && settingMap[settingId] != undefined">
                        <b-row>
                            <b-col class="md-2">
                                <b>Store Id:</b>
                            </b-col>
                            <b-col>
                                {{settingMap[settingId].id}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Vertrag notwendig:</b>
                            </b-col>
                            <b-col>
                                {{settingMap[settingId].contractRequired}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Pausenzeit:</b>
                            </b-col>
                            <b-col>
                                {{settingMap[settingId].defaultBreakTime}}
                            </b-col>
                            <b-col class="md-2">
                                <b>UTC Abweichung:</b>
                            </b-col>
                            <b-col>
                                {{settingMap[settingId].utcOffset}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Lizenz bis:</b>
                            </b-col>
                            <b-col>
                                {{settingMap[settingId].licExpiry}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Auto. Dienstplan Lizenz bis:</b>
                            </b-col>
                            <b-col>
                                {{settingMap[settingId].asLicExpiry}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Wetter Lizenz bis:</b>
                            </b-col>
                            <b-col>
                                {{settingMap[settingId].weatherLicExpiry}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Historisches Wetter Lizenz bis:</b>
                            </b-col>
                            <b-col>
                                {{settingMap[settingId].hWeatherLicExpiry}}
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col class="md-2">
                                <b>Latitude:</b>
                            </b-col>
                            <b-col>
                                {{settingMap[settingId].latitude}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Longitude:</b>
                            </b-col>
                            <b-col>
                                {{settingMap[settingId].longitude}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Geöffnet von:</b>
                            </b-col>
                            <b-col>
                                {{settingMap[settingId].openFrom}}
                            </b-col>
                            <b-col class="md-2">
                                <b>geöffnet bis:</b>
                            </b-col>
                            <b-col>
                                {{settingMap[settingId].openTo}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Max. Anzahl Plan Typen:</b>
                            </b-col>
                            <b-col>
                                {{settingMap[settingId].employeeTypeCountMax}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Max. Anzahl Plan Optionen:</b>
                            </b-col>
                            <b-col>
                                {{settingMap[settingId].employeeRulesCountMax}}
                            </b-col>
                        </b-row>
                       
                        
                    </div>
                </b-tab>
                
            </b-tabs>
        </b-card>   
        </b-container>
    </b-modal>

    
  </div> 

</template>

<script>
export default {
  name: 'storesettings',
  data () {
    return {
      settings: [],
      settingMap:{},
      fields: [{key:"id", thClass: 'documentsTh', tdClass: 'documentsTd',label:"Store Id"}, {key:"licExpiry", thClass: 'documentsTh', tdClass: 'documentsTd',label:"Lizenz Ablaufdatum"},
               {key:"openFrom", thClass: 'documentsTh', tdClass: 'documentsTd', label:"Geöffnet Von"}, {key:"openTo", thClass: 'documentsTh', tdClass: 'documentsTd', label:"Geöffnet Bis"}, 
               {key:"contractRequired", thClass: 'documentsTh', tdClass: 'documentsTd', label:"Vertrag notwendig"}, {key:"latitude", thClass: 'documentsTh', tdClass: 'documentsTd', label:"Latitude"}, 
               {key:"longitude", thClass: 'documentsTh', tdClass: 'documentsTd', label:"Longitude"}, 
               {key:"utcOffset", thClass: 'documentsTh', tdClass: 'documentsTd',label:"UTC Abweichung"}, {key:"defaultBreakTime", thClass: 'documentsTh', tdClass: 'documentsTd',label:"Pausenzeit"}, 
               {key:"actions", label:"", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: false}],
      settingId:"",
      currentSettingRow: undefined,
      groupMap : {},
      storeSetting: {
          id: null,
          licExpiry: null,
          asLicExpiry: null,
          weatherLicExpiry: null,
          hWeatherLicExpiry: null,
          openFrom: null,
          openTo: null,
          contractRequired: false,
          latitude: null,
          longitude: null,
          employeeTypeCountMax: null,
          employeeRulesCountMax: null,
          defaultBreakTime: 30,
          utcOffset:0
          
      },
      settingerror: false,
    }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
        this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function(){
        let view = this;
        
        view.loadStoreSettings()
        .then(response => {
            view.updateStoreSettings(response.data);
        }).catch(function (error) {
            console.log(error)
         })

    },
    openEditModal: function(row){
        this.currentSettingRow = row;
        this.settingId = row.item.id;
        
        this.storeSetting.latitude = row.item.latitude;
        this.storeSetting.longitude = row.item.longitude;
        this.storeSetting.openFrom = this.$helpers.extractTimeString(row.item.openFrom);
        this.storeSetting.openTo = this.$helpers.extractTimeString(row.item.openTo);
        this.storeSetting.defaultBreakTime = row.item.defaultBreakTime;
        this.storeSetting.utcOffset = row.item.utcOffset;
        this.storeSetting.contractRequired = row.item.contractRequired;
        
        this.showModal('modal-editsetting');
    },
    
    editStoreSetting: function(evt){
        evt.preventDefault();
        this.settingerror=false;
        let view = this;
        let url = '/api/sec/storesettings';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storesettings');
        
        let payload = {
          id: this.settingId,
          updateFields:["latitude", "longitude", "openFrom", "openTo", "contractRequired", "utcOffset", "defaultBreakTime"],
          latitude: this.storeSetting.latitude,
          longitude: this.storeSetting.longitude,
          openFrom: this.$helpers.convertDateTimeString(null, this.storeSetting.openFrom),
          openTo: this.$helpers.convertDateTimeString(null, this.storeSetting.openTo),
          contractRequired: this.storeSetting.contractRequired,
          defaultBreakTime: this.storeSetting.defaultBreakTime,
          utcOffset: this.storeSetting.utcOffset
        }

        

        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            
            view.currentSettingRow.item.latitude = view.storeSetting.latitude;
            view.currentSettingRow.item.longitude = view.storeSetting.longitude;
            view.currentSettingRow.item.openFrom = payload.openFrom;
            view.currentSettingRow.item.openTo = payload.openTo;
            view.currentSettingRow.item.contractRequired = view.storeSetting.contractRequired;
            view.currentSettingRow.item.defaultBreakTime = view.storeSetting.defaultBreakTime;
            view.currentSettingRow.item.utcOffset = view.storeSetting.utcOffset;
            let settingMapItem = view.settingMap[view.settingId];

            if(settingMapItem != undefined){
                for (let property in payload) {
                    if (payload.hasOwnProperty(property) && settingMapItem.hasOwnProperty(property)) {
                        settingMapItem[property] = payload[property];
                    }
                }
            }
          
            
            view.hideModal('modal-editsetting');
            
            
        }).catch(function (error) {
            view.settingerror=true;
            console.log(error)
        })

    },
    
   
    openViewModal: function(row){
        this.currentSettingRow = row;
        this.settingId = row.item.id;
        
        this.showModal('modal-viewsetting');
    },
    loadStoreSettings : function() {
      
      let url = '/api/sec/storesettings';

      url = this.$helpers.appendParam("id", this.$store.state.storeId, url, '/api/sec/storesettings');
      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storesettings');
      
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    updateStoreSettings: function(data){
        
        let tsettingMap = {};
        let settings = [];
        
        let settingMapItem = data;
        tsettingMap[data.id] = settingMapItem;
        settings.push(settingMapItem);
        
        this.settingMap = tsettingMap;
        this.settings = settings;
    },
    
    
    hideModalWithoutReset (ref) {
        this.settingerror=false;
        this.$refs[ref].hide();
    },
    resetRuleSettingValues(){
        this.storeSetting = {
          id: null,
          licExpiry: null,
          asLicExpiry: null,
          weatherLicExpiry: null,
          hWeatherLicExpiry: null,
          openFrom: null,
          openTo: null,
          contractRequired: false,
          defEmpGroup: null,
          latitude: null,
          longitude: null,
          employeeTypeCountMax: null,
          employeeRulesCountMax: null,
          defaultBreakTime: 30,
          utcOffset:0
            
      };
    },
    
    
    hideModal (ref) {
       
        this.resetRuleSettingValues();

        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.$refs[ref].show()
    }
  },
  computed: {
   
  },
  watch: { 
    
  }

}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>

</style>
